import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link } from "react-router-dom";

import { DefaultContext } from '../../context/context_default';

import ItemListDeck from '../deckList/componente/itemListDeck';
import ItemListDeckBuild from '../deckBuild/componente/itemList';
import GraficoBarras from "../deckBuild/componente/grafico_barras"

import imgBG from "../../assets/imagens/communit-155.jpg";
import imgPrimura from "../../assets/imagens/primura-face-60.png";
import imgEnneda from "../../assets/imagens/enneda-face-80.png";

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useDeckCommunit } from './hook';

import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SortIcon from '@mui/icons-material/Sort';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const DeckCommunit = () => {

	const {
		listDecksUser,
		deckSelect,
		setDeckSelect,
		changeDeck,
		isOpenDeck,
		toggleDrawerDeck,
		estiloCard,
		NextPlan,
		snapSize,
		handleInputChange,
		toggleDrawerFilter,
		isOpenFilter,
		loadMoreDecks,
		hasMore,
		loading,
		handleLike,
		filters,
		applyFilters,
		getQuebradores,
		isQuebrador
	} = useDeckCommunit();
	const {
		globalFirestoreData,
		listCardDeck,
		showListCards,
		listCards,
		showCardFlutuante,
		is_descktop,
		setDeck_tu_edit,
		conta_cartas_lsit,
		setShowCardFlutuante,
		tipos,
		subTipos,
		palavraChave,
		causas
	} = useContext(DefaultContext);
	const divider = () => { return (<div className='flex-1 border-b border-slate-600 h-0'></div>) }

	const estiloDoComponente = {
		WebkitFilter: 'drop-shadow(0px 0px 4px #0f0f0f)',
		filter: 'drop-shadow(0px 0px 4px #0f0f0f)',
	};

	const estiloDoComponenteImg = {
		WebkitFilter: 'drop-shadow(0px 0px 2px #000000)',
		filter: 'drop-shadow(0px 0px 2px #000000)',
	};

	const handleNavigateExternal = (id) => {
		const currentURL = window.location.href;
		window.open(currentURL.split("/")[0] + "/detail/" + id, '_blank');
	};
	useEffect(() => {
		if (!isOpenDeck) {
			setShowCardFlutuante(false);
		}
	}, [isOpenDeck])



	return (
		<div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
			<div className={`${isOpenDeck || isOpenFilter ? 'md:mr-[320px] duration-200' : 'mr-0 duration-200'} bg-slate-700 bg-opacity-[94%] w-full h-full pt-16 transition-all  `}>

				<div id='lista' className='bg-gradient-to-b from-transparent via-transparent to-slate-900 w-full h-full p-4 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm'>
					<div className='mb-6'>
						<h2 className='min-w-fit text-3xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-2'>Galeria de Decks</h2>
						<p className='min-w-fit text-slate-300 text-base leading-relaxed'>Veja listas de cartas de toda a comunidade Effect e se inspire para criar sua nova estratégia!</p>
						{/* <div className='w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mt-3'></div> */}
					</div>
					<div className='flex space-x-2 mb-4 items-end'>
						<div className='flex-1 flex lg:space-x-2 lg:flex-row flex-col lg:items-center justify-start'>
							{/* Barra de busca */}
							<div className="relative w-full lg:w-80 mb-2 lg:mb-0">
								<div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
									<SearchRoundedIcon className='text-slate-400'></SearchRoundedIcon>
								</div>
								<input
									type="text"
									id="simple-search"
									onChange={handleInputChange}
									className="border text-sm rounded-lg block w-full ps-10 p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
									placeholder="Procure pelo nome de algum deck..."
								/>
							</div>

							{/* Filtros rápidos */}
							<div className='flex space-x-2'>
								{/* Ordenação */}
								<select
									value={filters.orderBy}
									onChange={(e) => applyFilters({ orderBy: e.target.value })}
									className='bg-slate-600 hover:bg-slate-500 text-white text-sm rounded-lg px-3 py-2 border border-slate-500 focus:ring-blue-500 focus:border-blue-500'
								>
									<option value='timestamp'>Mais Recentes</option>
									<option value='likes'>Mais Curtidos</option>
								</select>

								{/* Filtro por Causa */}
								<select
									value={filters.causa}
									onChange={(e) => applyFilters({ causa: e.target.value })}
									className='bg-slate-600 hover:bg-slate-500 text-white text-sm rounded-lg px-3 py-2 border border-slate-500 focus:ring-blue-500 focus:border-blue-500'
								>
									<option value=''>Todas as Causas</option>
									{causas?.map(causa => (
										<option key={causa.id} value={causa.id}>{causa.causa}</option>
									))}
								</select>
							</div>
						</div>
						<div className='p-2.5 bg-slate-600 hover:bg-slate-500 text-white w-10 h-10 flex justify-center items-center cursor-pointer rounded-lg transition-colors duration-200' onClick={() => { toggleDrawerFilter(!isOpenFilter) }} title='Filtros Avançados'>
							<FilterAltRoundedIcon></FilterAltRoundedIcon>
						</div>
					</div>


					<div className='flex flex-wrap gap-4 justify-start'>

						{<div className={`${showCardFlutuante && is_descktop ? "" : "hidden"} w-40 h-auto  right-80 mr-2 absolute z-40`} style={estiloCard}>
							{/* <img className=' w-full h-full object-contain' style={estiloDoComponente} src={showCardFlutuante?.url_img} loading="lazy" ></img> */}
							<div className={`bg-slate-800 text-white shadow-md border-l-4 border-blue-500`}>
								<div className='p-2 pb-0'>{showCardFlutuante?.card?.nome}</div>
								<div className='p-2 pt-0 text-xs'>{showCardFlutuante?.card?.tipo?.map(e => tipos?.find(t => t.id == e)?.tipo + ' ')} / {showCardFlutuante?.card?.sub_tipo?.map(e => subTipos?.find(t => t.id == e)?.tipo + ' ')}</div>

								{showCardFlutuante?.card?.custo || showCardFlutuante?.card?.poder || showCardFlutuante?.card?.vida ? <div className='border-b border-slate-700 '></div> : null}
								{showCardFlutuante?.card?.custo ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Custo:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante?.card?.custo}</div>  </div> : null}
								{showCardFlutuante?.card?.p_a ? <div className='p-2 pb-0 pt-0 flex justify-between items-center text-xs'><div>Poder:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante?.card?.p_a}</div> </div> : null}
								{showCardFlutuante?.card?.vida ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Vida:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante?.card?.vida}</div> </div> : null}


								{showCardFlutuante?.card?.p_c?.length > 0 ? <div className='border-b border-slate-700 '></div> : null}
								{showCardFlutuante?.card?.p_c?.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'>Palavras chave</div> : null}
								{palavraChave && showCardFlutuante?.card ? showCardFlutuante?.card.p_c?.map(id => { return <div className='p-2 pb-0 pt-0 text-xs flex justify-start items-center'><div className='rounded-full w-1 h-1 bg-slate-300 mr-2 ml-2 '></div><div>{palavraChave?.find(item => item.id == id)?.nome} </div></div> }) : null}
								{showCardFlutuante?.card?.p_c?.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'></div> : null}
							</div>
						</div>}

						{/* <Link to='/deck-build' className=' bg-slate-600 md:w-44 md:h-56 w-36 h-48 border border-slate-700 rounded-2xl shadow hover:bg-slate-500 cursor-pointer p-1 mt-[8px] ml-[8px] '>
                            <div className='flex justify-center items-center w-full h-full border rounded-xl border-slate-400 border-opacity-50'>
                                <AddRoundedIcon className=" text-gray-20 scale-[2] "></AddRoundedIcon>
                            </div>


                        </Link> */}

						{listDecksUser ? listDecksUser.map((item, index) => {
							return (
								<div key={index} onClick={() => { toggleDrawerDeck(true); changeDeck(item) }} className='flex-none w-44 h-56 sm:w-48 sm:h-60 md:w-52 md:h-64 transform transition-all duration-200 hover:scale-105 cursor-pointer'>
									<ItemListDeck
										deck={item}
										profile={true}
										onLike={handleLike}
										showLikeButton={true}
									></ItemListDeck>
								</div>
							)
						}) : null}

						{/* Loading indicator */}
						{loading && (
							<div className='col-span-full flex justify-center py-8'>
								<div className='flex items-center space-x-3 text-slate-300 bg-slate-800 bg-opacity-50 px-6 py-3 rounded-lg border border-slate-600'>
									<div className='animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500'></div>
									<span className='font-medium'>Carregando decks...</span>
								</div>
							</div>
						)}

						{/* Load more button */}
						{!loading && hasMore && (
							<div className='col-span-full flex justify-center py-8'>
								<button
									onClick={loadMoreDecks}
									className='bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 flex items-center space-x-2 border border-blue-500 border-opacity-30'
								>
									<span>Carregar Mais Decks</span>
									<svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
										<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
									</svg>
								</button>
							</div>
						)}

						{/* End of list message */}
						{/* {!loading && !hasMore && listDecksUser?.length > 0 && (
							<div className='col-span-full flex justify-center py-8'>
								<div className='text-slate-400 text-sm bg-slate-800 bg-opacity-50 px-6 py-3 rounded-lg border border-slate-600 shadow-lg'>
									🎯 Todos os decks foram carregados!
								</div>
							</div>
						)} */}

						{/* Empty state */}
						{!loading && listDecksUser?.length === 0 && (
							<div className='col-span-full w-full flex flex-col items-center justify-center py-16'>
								<div className='text-slate-400 text-center bg-slate-800 bg-opacity-30 p-8 rounded-xl border border-slate-600 border-opacity-50'>
									<div className='text-6xl mb-4 animate-bounce'>🎴</div>
									<h3 className='text-xl font-semibold mb-2 text-slate-300'>Nenhum deck encontrado</h3>
									<p className='text-sm text-slate-400'>Seja o primeiro a compartilhar um deck com a comunidade!</p>
								</div>
							</div>
						)}

						{/* Painel de Filtros Avançados */}
						<aside className={`${isOpenFilter ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '} overflow-x-visible bg-gradient-to-b from-slate-700 to-slate-800 pt-16 transition-transform fixed top-0 right-0 z-30 w-80 h-screen shadow-2xl flex flex-col p-4 border-l border-slate-600 border-opacity-60 backdrop-blur-sm`}>
							<div className='flex flex-col justify-start overflow-y-auto scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600 scrollbar-rounded-sm pr-2 h-full pt-4'>
								<div className='flex justify-between w-full mb-6 pb-4 border-b border-slate-600 border-opacity-50'>
									<div className='flex items-center flex-1'>
										<div className='flex flex-col'>
											<span className='text-lg font-semibold text-white cursor-pointer'>Filtros Avançados</span>
											<span className='text-xs text-slate-400 mt-1'>Personalize sua busca</span>
										</div>
									</div>
									<div className='rounded-full w-8 h-8 flex justify-center items-center bg-slate-600 hover:bg-slate-500 cursor-pointer transition-colors duration-200' onClick={() => { toggleDrawerFilter(false) }}>
										<CloseRoundedIcon className='text-slate-300'></CloseRoundedIcon>
									</div>
								</div>

								{/* Ordenação */}
								<div className='mb-6'>
									<label className='block text-sm font-medium text-slate-300 mb-2'>Ordenar por</label>
									<div className='space-y-2'>
										<label className='flex items-center space-x-3 cursor-pointer p-2 rounded-lg hover:bg-slate-600 hover:bg-opacity-50 transition-colors duration-200'>
											<input
												type='radio'
												name='orderBy'
												value='timestamp'
												checked={filters.orderBy === 'timestamp'}
												onChange={(e) => applyFilters({ orderBy: e.target.value })}
												className='text-blue-500 focus:ring-blue-500'
											/>
											<AccessTimeIcon className='text-slate-400 h-4 w-4' />
											<span className='text-slate-300'>Data de Criação</span>
										</label>
										<label className='flex items-center space-x-3 cursor-pointer p-2 rounded-lg hover:bg-slate-600 hover:bg-opacity-50 transition-colors duration-200'>
											<input
												type='radio'
												name='orderBy'
												value='likes'
												checked={filters.orderBy === 'likes'}
												onChange={(e) => applyFilters({ orderBy: e.target.value })}
												className='text-red-500 focus:ring-red-500'
											/>
											<FavoriteIcon className='text-red-400 h-4 w-4' />
											<span className='text-slate-300'>Quantidade de Likes</span>
										</label>
									</div>
								</div>

								{/* Filtro por Causa */}
								<div className='mb-6'>
									<label className='block text-sm font-medium text-slate-300 mb-2'>Tipo de Causa</label>
									<select
										value={filters.causa}
										onChange={(e) => applyFilters({ causa: e.target.value })}
										className='w-full bg-slate-600 border border-slate-500 text-white text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500'
									>
										<option value=''>Todas as Causas</option>
										{causas?.map(causa => (
											<option key={causa.id} value={causa.id}>{causa.causa}</option>
										))}
									</select>
								</div>

								{/* Filtro por Quebrador */}
								<div className='mb-6'>
									<label className='block text-sm font-medium text-slate-300 mb-2'>Quebrador</label>
									<select
										value={filters.quebrador}
										onChange={(e) => applyFilters({ quebrador: e.target.value })}
										className='w-full bg-slate-600 border border-slate-500 text-white text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500'
									>
										<option value=''>Todos os Quebradores</option>
										{getQuebradores()?.map(card => (
											<option key={card.id} value={card.id}>{card.nome}</option>
										))}
									</select>
								</div>

								{/* Botão para limpar filtros */}
								<div className='mt-auto pt-4 border-t border-slate-600 border-opacity-50'>
									<button
										onClick={() => applyFilters({ orderBy: 'timestamp', causa: '', quebrador: '' })}
										className='w-full bg-slate-600 hover:bg-slate-500 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200'
									>
										Limpar Filtros
									</button>
								</div>
							</div>
						</aside>
						<aside className={`${isOpenDeck ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '} overflow-x-visible bg-gradient-to-b from-slate-700 to-slate-800 pt-16 transition-transform fixed top-0 right-0 z-30 w-80 h-screen shadow-2xl flex flex-col p-4 border-l border-slate-600 border-opacity-60 backdrop-blur-sm`}>

							{deckSelect ?
								<div className='flex flex-col justify-start overflow-y-auto scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600 scrollbar-rounded-sm pr-2 h-full pt-4'>
									<div className='flex justify-between w-full mb-6 pb-4 border-b border-slate-600 border-opacity-50'>
										<div className='flex items-center flex-1'>
											<div className='flex flex-col'>
												<span className='text-lg font-semibold text-white cursor-pointer truncate ellipsis w-56'>{deckSelect.nome}</span>
												<span className='text-xs text-slate-400 mt-1'>Detalhes do Deck</span>
											</div>
										</div>

										<div className='rounded-full w-8 h-8 flex justify-center items-center bg-slate-600 hover:bg-slate-500 cursor-pointer transition-colors duration-200 ml-3' onClick={() => { toggleDrawerDeck(false) }}>
											<CloseRoundedIcon className='text-slate-300'></CloseRoundedIcon>
										</div>

									</div>

									<div className='flex items-center justify-around space-x-3 my-4 rounded-lg border border-slate-600 border-opacity-50 bg-gradient-to-r from-slate-800 to-slate-700 bg-opacity-70 p-4 shadow-lg'>
										<div className='text-2xl text-slate-200 flex flex-col items-center'>
											<div className='text-xs font-medium text-slate-400 mb-1'>Árvore</div>
											<div className='font-bold text-blue-400'>
												{conta_cartas_lsit(deckSelect.arvore)}/
												{conta_cartas_lsit(deckSelect.arvore) > 40 ? '50' : conta_cartas_lsit(deckSelect.arvore) > 30 ? '40' : '30'}
											</div>
										</div>
										<div className='w-px h-8 bg-slate-600'></div>
										<div className='text-2xl text-slate-200 flex flex-col items-center'>
											<div className='text-xs font-medium text-slate-400 mb-1'>Matriz</div>
											<div className='font-bold text-purple-400'>
												{conta_cartas_lsit(deckSelect.matriz)}/
												{conta_cartas_lsit(deckSelect.matriz) > 40 ? '50' : conta_cartas_lsit(deckSelect.matriz) > 30 ? '40' : '30'}
											</div>
										</div>

									</div>
									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-slate-600 bg-opacity-50 px-2 py-1 rounded'>QUEBRADOR</span>
										{divider()}
									</div>

									<div>
										{deckSelect.quebrador ? <ItemListDeckBuild item={{ id: deckSelect.quebrador }} lessItem={() => { handleNavigateExternal(deckSelect.quebrador) }} addItem={() => { }} className='overflow-x-visible' > </ItemListDeckBuild> : null}
									</div>



									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-blue-600 bg-opacity-30 px-2 py-1 rounded'>ÁRVORE</span>
										{divider()}
									</div>
									<GraficoBarras listCardDeck={deckSelect.arvore}></GraficoBarras>

									{/* <div className=' border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[300px] h-fit  overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600  scrollbar-rounded-sm p-1'>
                                        {deckSelect.arvore.map(item => <ItemListDeckBuild item={item} lessItem={() => { handleNavigateExternal(item.id) }} addItem={() => { }} className='overflow-x-visible' > </ItemListDeckBuild>)}
                                    </div> */}

									<div className="flex flex-col justify-center items-center w-full mt-5">
										<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
											<div className="h-auto">
												{deckSelect.arvore.map((item, index) => (
													<ItemListDeckBuild
														key={index}
														item={item}
														lessItem={() => { handleNavigateExternal(item.id) }}
														addItem={() => { }}
														className="overflow-x-visible"
													/>
												))}
											</div>
										</div>
									</div>

									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-purple-600 bg-opacity-30 px-2 py-1 rounded'>MATRIZ</span>
										{divider()}
									</div>

									{/* <GraficoBarras></GraficoBarras> */}
									{/* <div className=' border border-dashed border-gray-500 rounded-md w-full  min-h-[200px] max-h-[300px] h-fit overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600  scrollbar-rounded-sm p-1'>
                                        {deckSelect.matriz.map(item => <ItemListDeckBuild item={item} lessItem={() => { handleNavigateExternal(item.id) }} addItem={() => { }} className='overflow-x-visible' > </ItemListDeckBuild>)}
                                    </div> */}

									<div className="flex flex-col justify-center items-center w-full mt-5">
										<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
											<div className="h-auto">
												{deckSelect.matriz.map((item, index) => (
													<ItemListDeckBuild
														key={index}
														item={item}
														lessItem={() => { handleNavigateExternal(item.id) }}
														addItem={() => { }}
														className="overflow-x-visible"
													/>
												))}
											</div>
										</div>
									</div>

									<div className='flex justify-center mt-8 select-none mb-6'>
										<Link to={`/deck/${deckSelect.id}`} className='bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 cursor-pointer rounded-lg px-6 py-3 flex items-center space-x-2 text-white transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl border border-blue-500 border-opacity-30'>
											<VisibilityIcon className='text-sm' />
											<span className='font-medium'>Ver Detalhes</span>
										</Link>
									</div>

									{/* <div className='flex justify-end mt-4 select-none mb-6'>
                                        <Link to='/edita-deck' onClick={() => { setDeck_tu_edit(deckSelect) }} className={`bg-orange-500 hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2`}  >Editar</Link>
                                    </div> */}
									{/* <div className='flex justify-end mt-4 select-none'>
                                    <div className={`${load ? "bg-orange-300" : "bg-orange-500"} hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2`} onClick={() => { salveDeck() }} disable={load} >Salvar</div>
                                </div> */}


								</div> : null}
						</aside>

					</div>
				</div>



			</div>

		</div>
	)
}

export default DeckCommunit